import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ToolbarItem'

export const TimelineCardSettings = (settingsProps) => {
  return (
    !settingsProps.floating && (
      <>
        <ToolbarSection title="Immagine 1" initOpen>
          <ToolbarItem
            propKey="block"
            propSubKey="alt"
            type="text"
            label="Alt Text"
            defaultValue={defaultProps['alt']}
          />
          <ToolbarItem
            propKey="block"
            propSubKey="image"
            type="text"
            label="Desktop"
            description="Paste your url or upload a file"
            defaultValue={defaultProps['image']}
          />
          <ToolbarItem propKey="block" propSubKey="image" type="image" />
        </ToolbarSection>
        <ToolbarSection title="Immagine 2" initOpen>
          <ToolbarItem
            propKey="block"
            propSubKey="alt2"
            type="text"
            label="Alt Text"
            defaultValue={defaultProps['alt2']}
          />
          <ToolbarItem
            propKey="block"
            propSubKey="image2"
            type="text"
            label="Desktop"
            description="Paste your url or upload a file"
            defaultValue={defaultProps['image2']}
          />
          <ToolbarItem propKey="block" propSubKey="image2" type="image" />
        </ToolbarSection>
      </>
    )
  )
}

export const TimelineCardFloatingSettings = () =>
  React.createElement(TimelineCardSettings, { floating: true })
